<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Avans</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <!-- 
                ADVANCE/0 SAĞ ÜST MENÜ KODU
                <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a> -->
              <div class="m-dropdown__wrapper" style="z-index: 101;">
                <span
                  class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
                  style="left: auto; right: 21.5px;"
                ></span>
                <div class="m-dropdown__inner">
                  <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                      <ul class="m-nav">
                        <li class="m-nav__section m-nav__section--first m--hide">
                          <span class="m-nav__section-text">Quick Actions</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/advances'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Avans Ekle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right" method="POST">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Kodu</label>
                    <input type="text"  :class="{ 'is-invalid': $v.advance.advanceCode.$error }" v-model="advance.advanceCode" class="form-control m-input" placeholder="avans kodunu giriniz." />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea  :class="{ 'is-invalid': $v.advance.description.$error }" class="form-control m-input" v-model="advance.description" placeholder="Avans açıklamasını giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
                  <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Sahibi</label>
                    <input type="text"  :class="{ 'is-invalid': $v.advance.ownerUser.$error }" v-model="advance.ownerUser" class="form-control m-input" placeholder="Avans sahibini giriniz." disabled="disabled" />
                  </div>
                </div>
                
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Tutarı</label>
                    <input type="text"  :class="{ 'is-invalid': $v.advance.amount.$error }" v-model.number="advance.amount" class="form-control m-input" placeholder="Avans tutarını giriniz." />
                  </div>
                </div>
                 <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Talep Tarihi</label>
                       <datepicker
                        type="text"
                        format="dd.MM.yyyy"
                         
                        input-class="form-control"
                         :class="{ 'is-invalid': $v.advance.requestDate.$error }" v-model="advance.requestDate"
                         
                         placeholder="Avans Talep Tarihi "  
                      >
                      </datepicker>

                     </div>
                </div>

                  <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Tipi</label>
                    <select :class="{ 'is-invalid': $v.advance.advanceType.$error }" 
                            v-model="advance.advanceType" class="form-control m-input" 
                            placeholder="Avans Tipini giriniz.">
																			    <option
                                v-for="option in advanceTypes" 
                                v-bind:value="option.id"
                                v-bind:key="option.description"
                                >{{ option.description }}</option
                              >
                                      </select>
                  </div>
                </div>  

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Onay Durumu</label>
                    <input type="text"    v-model="advance.approveStatusName" class="form-control m-input" placeholder="Avans Onay Durumu giriniz." />
                  </div>
                </div>                         

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Avans Onay Tarihi</label>

                    <!-- TEST EDİLECEK. TARİHİ ALIP ALMADIĞINA GÖRE DÜZENLECEK -->
                    <input type="datetime-local" class="form-control m-input"
                     placeholder="Avans Onaylanmamış" 
                     format="dd.MM.yyyy"
                     disabled="disabled" 
                     v-model="advance.approveDate">

                    
                      <!-- Formatı bozduğu için kaldırıldı. Düz input eklendi. Satır 147 -->
                      <!-- <datepicker
                        type="text"
                        format="dd.MM.yyyy"
                         v-model="advance.approveDate" class="form-control m-input" 
                         placeholder="Onaylanmamış"
                         disabled="disabled" 
                      >
                      </datepicker> -->
                    </div>
                </div>  
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button v-if="approveItem != null && approveItem.id != 0" type="button" @click="approve()" class="spbtn">Onayla</button>
                      <button v-if="approveItem != null && approveItem.id != 0" type="button" @click="reject()" class="spbtn">Reddet</button>
                      <button v-if="approveItem == null || approveItem.id == 0" type="button" @click="advance.id==0?create():update()" class="spbtn">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required,   decimal } from "vuelidate/lib/validators";
import {_create,_getById,_update, _getAdvanceTypes} from '../../services/AdvanceService'
import {_approve,_getMyApproveIfExist, _reject} from '../../services/ApproveService'
import datepickerc from "vuejs-datepicker";

export default { 
components: {
    datepicker :datepickerc
  },
  
  created() {
  this.getTypes();
  
  if(Number(this.$route.params.id)!=0)
        {
          this.advance.id=Number(this.$route.params.id);
              this.getById();
              this.getMyApproveIfExist()

        }
},

  data() {
    return {
      advance:{
        id:0,
        advanceCode:'',
        description:'',
        ownerUserId: this.$store.getters.user.userId,
        ownerUser: this.$store.getters.user.email,
        amount:1,
        requestDate:new Date(),
        advanceType :null,
        approveStatus:0,
        approveStatusName:'',
        approveDate:null

      },
      advanceTypes:[],
 
      approveItem :{
        id : 0,
       approveReferenceType : null ,
       approvementStatusEnum : null ,
       referenceId :0

      }
    }
  },
    validations: {
    advance: {
      advanceCode: { required },
      description: { required },
      ownerUser:{ required },
      amount:{ required , decimal },
      requestDate:{ required },
      advanceType :{ required, decimal }

    }
  },
methods: {
  create:function(){
          this.$v.advance.$touch();
      if (this.$v.advance.$error) return;
    _create(this.advance).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'advances' })
    });
  },
  update:function(){
          this.$v.advance.$touch();
      if (this.$v.advance.$error) return;
    _update(this.advance).then(response=>{
      if(response.data.success)
        this.$router.push({ name: 'advances' })
    });
  },
  getById:function(){
    _getById(Number(this.$route.params.id)).then(response=>{
      if(response.data.success)
      this.advance=response.data.data;
      else
      this.$router.push({ name: 'advances' })
    })
  },
  getTypes:function(){
    _getAdvanceTypes().then(response=>{
      if(response.data.success)
      this.advanceTypes=response.data.data;
      else
      this.$router.push({ name: 'advances' })
    })
  },
       
       approve:function(dialog){

if (this.advance.id != 0)
{
        _approve(this.approveItem).then(response=>{
          if(response.data.success)
              this.$router.push({ name: 'advances' })
        });
              dialog.close();
          }
             },


              reject:function(dialog){

if (this.advance.id != 0)
{
        _reject(this.approveItem).then(response=>{
          if(response.data.success)
              this.$router.push({ name: 'advances' })
        });
              dialog.close();
          }
             },

    getMyApproveIfExist:function(){
        _getMyApproveIfExist({referenceId : this.advance.id , referenceType : 1} ).then(response=>{
          if(response.data.success)
          this.approveItem = response.data.data;
        });
 
    }
},
};
</script>